import React, { useEffect, useState, useRef } from 'react';

import {
    Container,
    Row,
    Col,
    Heading,
    Slider,
    className,
} from 'aplazame-design-system';
import { useTranslate } from 'soluble-gatsby-source';

import HeaderResourcesSection from '../HeaderResourcesSection';
import CardClientStoryComponent from '../CardClientStoryComponent';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';

const sliderSettings = {
    controls: true,
    controlsText: ['&nbsp;', '&nbsp;'],
    loop: false,
    nav: false,
    mouseDrag: true,
    items: 1,
    gutter: 40,
    edgePadding: 300,
    responsive: {
        1435: {
            edgePadding: 550,
        },
    },
};

export default function ClientStoriesSection({
    title,
    subtitle,
    detachedClientStories,
    clientStories,
}) {
    const translation = useTranslate();


    const [currentSlide, setCurrentSlide] = useState(0);
    const [isFirst, setIsFirst] = useState(true);
    const [isLast, setIsLast] = useState(false);
    const sliderRef = useRef();

    useEffect(() => {
        const configureClasses = (slider) => {
            setIsFirst(slider.index === 0 ? true : false);
            setIsLast(slider.index + 1 === slider.slideCount ? true : false);
        };

        if (sliderRef.current) {
            sliderRef.current.slider.events.on(
                'indexChanged',
                configureClasses
            );
        }

        return () => {
            if (sliderRef.current) {
                sliderRef.current.slider.events.off(
                    'indexChanged',
                    configureClasses
                );
            }
        };
    }, [setIsFirst, setIsLast, sliderRef]);

    return (
        <>
            <HeaderResourcesSection
                title={title}
                subtitle={subtitle}
                extraContent={
                    detachedClientStories && detachedClientStories.length ? (
                        <div
                            className={`${style['detached-wrapper']} ${colorStyle['bg--quaternary-200']}`}
                        >
                            <Container
                                pt={{ xs: 5, lg: 7 }}
                                pb={{ xs: 1, lg: 9 }}
                            >
                                <Heading
                                    tag="h3"
                                    className={style.headerExtraContent}
                                    mb={{ xs: 5, lg: 7 }}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                >
                                    {
                                        translation[
                                            'client-stories-section.detached.title'
                                        ].text
                                    }
                                </Heading>
                                <Row className="d-lg-none">
                                    {detachedClientStories.map(
                                        (clientStory, i) => (
                                            <Col
                                                key={i}
                                                pb={{ xs: 6 }}
                                                data-sal="slide-up"
                                                data-sal-easing="ease-out-quart"
                                                data-sal-delay={`xs-none--lg-${900 + (i % 3) * 200
                                                    }`}
                                            >
                                                <CardClientStoryComponent
                                                    {...clientStory}
                                                    detached={true}
                                                />
                                            </Col>
                                        )
                                    )}
                                </Row>
                                <div
                                    {...className(
                                        `${style.slider} ${isFirst
                                            ? style['slider--in-first']
                                            : ''
                                        } ${isLast
                                            ? style['slider--in-last']
                                            : ''
                                        } d-none d-lg-block`
                                    )}
                                >
                                    <Slider
                                        parentRef={sliderRef}
                                        settings={sliderSettings}
                                        onIndexChanged={(event) => setCurrentSlide(event.index)}
                                    >
                                        {detachedClientStories.map(
                                            (clientStory, i) => (
                                                <div
                                                    key={i}
                                                    {...className(
                                                        `${style['slider__slide']}`
                                                    )}
                                                >
                                                    <CardClientStoryComponent
                                                        {...clientStory}
                                                        detached={true}
                                                    />
                                                </div>
                                            )
                                        )}
                                    </Slider>
                                </div>
                                <div className={style.paginationContainer}>{currentSlide + 1}/{detachedClientStories.length}</div>
                            </Container>
                        </div>
                    ) : null
                }
            />
            <section>
                <Container pb={{ xs: 15, lg: 9 }} pt={{ lg: 7 }}>
                    <Row>
                        {clientStories && clientStories.length
                            ? clientStories.map((clientStory, i) => (
                                <Col
                                    key={i}
                                    col={{ md: 6, lg: 4 }}
                                    pb={{ xs: 7, lg: 8 }}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    data-sal-delay={`xs-none--lg-${(i % 3) * 200
                                        }`}
                                >
                                    <CardClientStoryComponent
                                        {...clientStory}
                                    />
                                </Col>
                            ))
                            : null}
                    </Row>
                </Container>
            </section>
        </>
    );
}
